module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.error) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v(_vm._s(_vm.error.message))])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "name": "email",
      "label": "E-Mail-Adresse",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": _vm.$vars.loading,
      "loading": _vm.$vars.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSignin()
      }
    }
  }, [_vm._v("\n        Passwort Zurücksetzen\n          "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/anmelden"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n        Anmelden\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39886eac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/updatePasswordForm.vue
// module id = 759
// module chunks = 15